import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { CookieService } from "ngx-cookie-service";
import { BlurEvent, ChangeEvent } from "@ckeditor/ckeditor5-angular";
import Adapter from "src/app/core/services/ckeditorAdapter";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { noWhiteSpaceValidator } from "src/app/shared/directive/validators";

@Component({
  selector: 'app-addsuppportticketsmerchant',
  templateUrl: './addsuppportticketsmerchant.component.html',
  styleUrls: ['./addsuppportticketsmerchant.component.scss']
})
export class AddsuppportTicketsMerchantComponent implements OnInit, OnDestroy {
  breadcrumbItems: breadcrumbItem[] = [
    { label: 'Home', active: false, url: "/home" },
    { label: 'Support Tickets', active: false, url: "/support-tickets-merchant" },
    { label: 'Create Support Ticket', active: true, url: "/support-tickets-merchant/add" },
  ];

  public componentEvents: string[] = [];
  public editorContent: string = ''; // CKEditor content
  public Editor = ClassicEditor;

  merchantIssueId: string;
  merchantIssueForm: FormGroup;
  commentForm: FormGroup;
  replyForms: FormGroup[] = [];
  replyVisibility: boolean[] = [];
  isLoadingChangeSub: Subscription;
  isLoading: boolean = false;
  merchantIssue: any;
  GLOBALURL = this.apiService.getBaseURL();
  isReadonly: boolean = true; // Set this to true or false based on your condition
  showAllComments: boolean = false;
  files: { file: File, uploadTime: Date }[] = [];
  userData = this.authService.getUserFromLocalStorage();


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<AppState>,
    private toastr: AlertService,
    private apiService: ApiService,
    private breadcrumbService: BreadcrumbService,
    private changeDetector: ChangeDetectorRef,
    private cookieService: CookieService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.setValue(this.breadcrumbItems);
    this.route.params.subscribe(params => {
      this.merchantIssueId = params['id'];
      this.initForm();
    });
  }

  ngOnDestroy(): void {
    if (this.isLoadingChangeSub) {
      this.isLoadingChangeSub.unsubscribe();
    }
  }

  initForm() {
    this.merchantIssueForm = this.fb.group({
      title: ['', Validators.required ],
      description: ['', Validators.required],
      commentText: ['',]
    });
  }

  onSubmit() {
    const storeId = this.cookieService.get("storeId");
    const merchantId = this.cookieService.get("merchantId");
    this.isLoading = true;
    if (storeId === "*") {
      this.toastr.clear();
      this.toastr.error("Please select a location first.");
      this.isLoading = false;
      return;
    }
    const value = this.merchantIssueForm.get('title')?.value?.trim()
    if (value.length <= 0) {
      this.toastr.clear();
      this.toastr.error("Please add valid title.");
      this.isLoading = false;
      return;
    }
    if (!this.merchantIssueForm.valid) {
      this.toastr.error('Please fill out all required fields.');
      this.isLoading = false;
      return;
    }

    const formData = new FormData();
    formData.append('merchantId', merchantId);
    formData.append('storeId', storeId);
    formData.append('employeeId', this.userData?.response?.employeeId);
    formData.append('createdEmployeeId', this.userData?.response?.employeeId);
    formData.append('issueTitle', this.merchantIssueForm.get('title').value);
    formData.append('description', this.merchantIssueForm.get('description').value);
    const contactInfo = {
      email: this.userData?.response?.email || "",
      phoneNumber: this.userData?.response?.mobile || "",
    };
    formData.append('contactInfo', JSON.stringify(contactInfo));

    this.files.forEach(fileObj => {
      formData.append('files', fileObj.file);
    });

    this.http.post(this.GLOBALURL + "/merchants/issues", formData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          const progress = Math.round(100 * event.loaded / event.total);
          console.log(`Upload progress: ${progress}%`);
        } else if (event.type === HttpEventType.Response) {
          const response = event.body;
          if (!response.error) {
            this.toastr.success("Merchant Issue created successfully.");
            this.isLoading = false;
            this.router.navigate(["support-tickets-merchant"]);
            const merchantIssueId = response.response.merchantIssueId;
            // if (this.merchantIssueForm.get('commentText').value) {
            //   this.addComment(merchantIssueId);
            // }
            // this.modalService.dismissAll();
            // this.offcanvasService.dismiss("cross click");
          } else {
            this.toastr.clear();
            this.toastr.error(response.message);
            this.isLoading = false;
          }
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
      }
    );
  }

  addComment(merchantIssueId: any): void {
    const payload: any = {
      comments: this.merchantIssueForm.get('commentText').value || "",
      merchantIssueId: merchantIssueId,
      employeeName: this.cookieService.get('employeeName'),
    };

    this.http.post(this.GLOBALURL + "/issues/comments", payload).subscribe(
      (response: any) => {
        if (!response.error) {
          // Handle success if needed
        } else {
          this.toastr.clear();
          this.toastr.error(response.message);
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
      }
    );
  }


  // onFilesAdded(event: any): void {
  //   const currentTime = new Date();
  //   this.files.push(...event.addedFiles.map((file: File) => ({ file, uploadTime: currentTime })));
  // }
  onFilesAdded(event: any): void {
    const MAX_SIZE = 5242880; // 5MB in bytes
    const currentTime = new Date();
    
    for (let file of event.addedFiles) {
        if (file.size > MAX_SIZE) {
            this.toastr.error(`File ${file.name} exceeds the maximum size of 5MB.`);
            return; // Stop processing further files
        }
        this.files.push({ file: file, uploadTime: currentTime });
    }
}

  onRemoveFile(file: { file: File, uploadTime: Date }): void {
    this.files.splice(this.files.indexOf(file), 1);
  }
  goBack() {
    this.router.navigate(["../"], { relativeTo: this.route });
  }
}